import { createFileRoute } from '@tanstack/react-router'

import { CoreSkillsAssessmentStepWelcome } from '@/core-skills-assessment/components/CoreSkillsAssessmentStepWelcome/CoreSkillsAssessmentStepWelcome'

export const Route = createFileRoute('/skills-assessment/welcome')({
  component: CoreSkillsAssessmentStepWelcome,
})
